import { useState } from "react";
import { toastr } from "react-redux-toastr";
import { Bold, Button, Input } from "../../generic-components";
import { ButtonContainer, ToastrConfirmInput } from "./style";

const ToastrInput = (props) => {
  const { metadata, dispatch, remove } = props;
  const [input, setInput] = useState("");
  return (
    <ToastrConfirmInput>
      <div>Type <Bold themed>{metadata.confirmationTerm}</Bold> in the field to confirm.</div>
      <Input placeholder={metadata.confirmationTerm} type="text" onChange={(e) => setInput(e.target.value)}/>
      <ButtonContainer>
        <Button expand danger disabled={input !== metadata.confirmationTerm} onClick={() => {
          if (metadata.action) metadata.noDispatch ? metadata.action(input) : dispatch(metadata.action);
          remove();
        }}>{metadata.actionText || "Confirm"}</Button>
        <Button expand primary onClick={() => {
          remove();
        }}>Cancel</Button>
      </ButtonContainer>
    </ToastrConfirmInput>
  );
};

export const showNotification =
  (type, title = "", message = "", metadata = {}) => async (dispatch) => {
    let config = {
      ...metadata,
      status: type === "input-confirm" ? "light" : type
    };
    if (metadata && metadata.action) config.onToastrClick = () => metadata.noDispatch ? metadata.action() : dispatch(metadata.action);
    if (metadata && metadata.timeOut) config.timeOut = metadata.timeOut;
    if (metadata && metadata.position) config.position = metadata.position;
    switch (type) {
      case "input-confirm":
        config.showCloseButton = false;
        config.onToastrClick = null;
        config.closeOnToastrClick = false;
        config.component = (props) => <ToastrInput metadata={metadata} dispatch={dispatch} {...props} />;
        toastr.message(title, message, config);
        break;
      case "success":
        toastr.success(title, message, config);
        break;
      case "info":
        toastr.info(title, message, config);
        break;
      case "warning":
        toastr.warning(title, message, config);
        break;
      case "error":
        toastr.error(title, message, config);
        break;
      case "delete":
        const deleteOptions = {
          onOk: () =>  metadata.noDispatch ? metadata.action() : dispatch(metadata.action),
          onCancel: () => {
            if (metadata.noDispatch && metadata.onCancel) metadata.action()
            else if (metadata.onCancel) dispatch(metadata.action);
            toastr.removeByType("confirms");
          },
          okText: metadata.okText || "Ok",
          cancelText: metadata.cancelText || "Cancel",
          disableCancel: metadata.disableCancel
        };
        toastr.confirm(title, deleteOptions);
        break;
      case "confirm":
        const confirmOptions = {
          onOk: () =>  metadata.noDispatch ? metadata.action() : dispatch(metadata.action),
          onCancel: () => toastr.removeByType("confirms"),
          okText: metadata.Yes || "Yes",
          cancelText: metadata.No || "No"
        };
        toastr.confirm(title, confirmOptions);
        break;
      default:
        break;
    }
  };
